// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import CreateAlertAccountLookupTemplate from '@front/templates/CreateAlertAccountLookupTemplate.html';
import { ContainerControl } from '../../elements/ContainerControl';
import { Resources } from '@shared/localizations/Resources';
import { ControlsTypes } from '../../UtilsClasses/FactoryConstants';
import { ResourcesManager } from '@shared/commons/properties/ResourcesManager';
export class CreateAlertAccountLookup extends ContainerControl {
    constructor() {
        super();
    }
    getType() {
        return ControlsTypes.CreateAlertAccountLookup;
    }
    oninit() {
        super.oninit();
        ResourcesManager.onLocaleChange.Subscribe(this.localize, this);
        this.localize();
    }
    dispose() {
        ResourcesManager.onLocaleChange.UnSubscribe(this.localize, this);
        super.dispose();
    }
    localize() {
        void this.set('label', Resources.getResource('screen.Alerts.Label.Account'));
    }
}
ContainerControl.extendWith(CreateAlertAccountLookup, {
    template: CreateAlertAccountLookupTemplate,
    data: function () {
        return {
            label: '',
            name: ControlsTypes.CreateAlertAccountLookup,
            account: null
        };
    }
});
